export class AppError extends Error {
  readonly userMessage: string
  readonly reportable: boolean
  requestId?: string
  code?: string

  constructor(
    userMessage: string,
    options?: {
      requestId?: string
      code?: string
      cause?: unknown
      reportable?: boolean
    },
  ) {
    super(userMessage, { cause: options?.cause })
    this.name = "AppError"
    this.userMessage = userMessage
    this.reportable = options?.reportable ?? true
    this.requestId = options?.requestId
    this.code = options?.code
  }
}

export function attachRequestId<T extends Error>(error: T, requestId?: string): T {
  if (requestId) {
    ;(error as T & { requestId?: string }).requestId = requestId
  }
  return error
}

export function getRequestIdFromError(error: unknown): string | undefined {
  if (error instanceof AppError) return error.requestId
  if (error && typeof error === "object" && "requestId" in error) {
    const value = (error as { requestId?: unknown }).requestId
    return typeof value === "string" ? value : undefined
  }
  return undefined
}

export function parseApiErrorBody(data: Record<string, unknown> | null): {
  message: string
  requestId?: string
  code?: string
} {
  const message =
    typeof data?.error === "string"
      ? data.error
      : typeof data?.message === "string"
        ? data.message
        : "Request failed"

  return {
    message,
    requestId: typeof data?.requestId === "string" ? data.requestId : undefined,
    code: typeof data?.code === "string" ? data.code : undefined,
  }
}
